/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/tumultkultur"

const tumultkultur: CommunityData = {
  code: "tumultkultur",
  name: "Tumult Kultur",
  inviteCode: "tumultkultur",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/tum-234`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#FF4D00",
      alternativeLogo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-[160px] object-contain",
      },
      logo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-[152px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#FF4D00",
      asideBg: "#ffffff",
      asideStyles: "border-l-[1px] border-grey",
      contentBg: "#ffffff",
      contentBoxShadow: "rounded-[24px]",
      bgDesktop: `${S3_PREFIX}/web-bg.jpg`,
      bgMobile: `${S3_PREFIX}/web-bg.jpg`,
      nonMemberBg: `${S3_PREFIX}/web-bg.jpg`,
      mainFont: "font-['Vevey-HumanKind']",
      primaryButton:
        "w-full sm:w-fit bg-[#FF4D00] text-[#FFFFFF] !px-6 !py-4 rounded-[8px] font-['Vevey-HumanKind'] text-[16px] leading-[24px] whitespace-nowrap",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "",
      separator: "",
      item: "sm:!pl-0 text-center opacity-50 !py-0 !pb-4",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0",
      titles: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] !font-normal tracking-[0.04em]",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-b border-grey",
        sectionTitle: "pl-4 sm:!pl-8 !pb-4 sm:!pb-6 !tracking-[0.04em]",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative !rounded-[16px]",
          media: "w-full !aspect-square object-cover !rounded-[16px]",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-[16px]",
          content: "flex flex-col pt-4 bg-[#ffffff]",
          title: "font-['Vevey-HumanKind'] text-[18px] text-[#FF4D00] leading-[1.2]",
          subtitle: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] leading-[1] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-b border-grey",
        sectionTitle: "pl-4 sm:pl-8 !pb-4 sm:!pb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden rounded-[16px]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 h-[256px] sm:!h-[128px] relative overflow-hidden rounded-[16px]",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400 sm:rounded-[16px] rounded-[16px]",
          content: "flex flex-col p-4 pl-0 sm:pl-4 sm:pt-0 bg-[#ffffff]",
          title: "font-['Vevey-HumanKind'] text-[18px] text-[#FF4D00] leading-[1.2]",
          subtitle: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] leading-[1] mt-2",
          location: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] leading-[1] mt-2",
          date: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] leading-[1] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:pb-8 !pb-16 !m-0 space-y-0",
        title: "font-['Vevey-HumanKind'] text-[20px] text-[#FF4D00]",
        text: "font-['Vevey-HumanKind'] text-[16px] text-[#FF4D00]",
        customShopImageStyle: "w-full h-full object-cover !rounded-[16px]",
        customShopImage:
          "https://media.werz.at/community-assets/tumultkultur/tumultkultur-landing-shop.png",
        sectionTitle: "!mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-grey",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 rounded-[16px] !border-0",
        title: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] tracking-[0.04em] mb-2",
        subtitle: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] mb-4",
        button: "!w-fit mb-4 sm:mb-0",
        questions: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-grey",
        header: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] tracking-[0.04em]",
        text: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-grey",
        header: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] tracking-[0.04em]",
        text: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] max-w-[652px] w-full",
        map: "sm:w-[350px] w-full h-[206px] !overflow-hidden !rounded-[16px]",
        mapPinColor: "#FF4D00",
        mapStrokeColor: "#FF4D00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] tracking-[0.04em]",
        text: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] sm:w-[550px]",
      },
      tickets: {
        header: "font-['Vevey-HumanKind'] text-[28px] text-[#FF4D00] tracking-[0.04em]",
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 py-4 border-b border-grey leading-auto tracking-[0.04em]",
          media: "!hidden",
          name: "font-['Vevey-HumanKind'] text-[18px] text-[#FF4D00]",
          description: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00]",
          price: "font-['Vevey-HumanKind'] text-[18px] text-[#FF4D00]",
          quantity: "font-['Vevey-HumanKind'] text-[18px] text-[#FF4D00]",
          status: "font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] text-right",
          counterContainer:
            "p-3 !w-fit font-['Vevey-HumanKind'] text-[14px] text-[#FF4D00] rounded-[8px] border border-[#FF4D00] rounded-[8px]",
          button:
            "font-['Vevey-HumanKind'] text-[14px] py-3 px-4 bg-[#FFFFFF] text-[#FF4D00] !w-fit  border border-[#FF4D00] rounded-[8px]",
          plusMinusColor: "#FF4D00",
        },
      },
    },
  },
}

export default tumultkultur
